import styled from 'styled-components';

interface IFullScreenContainerProps {
  backgroundColor?: string;
  isTinted?: boolean;
  canClickThrough?: boolean;
}

export const FullScreenContainer = styled.div`
  position:fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 500;
  pointer-events: ${(props: IFullScreenContainerProps) => props.canClickThrough ? 'none' : 'auto'};
  background: ${(props: IFullScreenContainerProps) => props.isTinted === undefined || props.isTinted ? (props.backgroundColor || 'rgba(9, 30, 66, 0.54)') : 'transparent'};
`;
